// extracted by mini-css-extract-plugin
export default {"CourseNav":"CourseNav_CourseNav__IUyk8","link":"CourseNav_link__eci1K"};